import { Star, Zap, Accessibility, Sparkles, HeartHandshake, ShieldCheck } from "lucide-react";
import { BookingWidget } from "@/components/booking/BookingWidget";

const BADGES = [
  { icon: Star, text: "5.0 ★ Rated Practice" },
  { icon: Zap, text: "Advanced Laser & Implant Center" },
  { icon: Accessibility, text: "Wheelchair Accessible Facility" },
];

const HIGHLIGHTS = [
  { icon: Sparkles, text: "Painless laser dentistry & smile makeovers" },
  { icon: ShieldCheck, text: "Dental implants with precise, honest planning" },
  { icon: HeartHandshake, text: "Gentle, patient-first approach — great with kids" },
];

const DoctorCard = () => (
  <div className="mt-8 flex gap-4 items-center rounded-2xl bg-white border border-mint-border/70 p-4 sm:p-5 shadow-[0_10px_30px_-18px_rgba(15,76,92,0.4)]" data-testid="hero-doctor-card">
    <img src="/images/doctor-portrait.jpg" alt="Dr. Vilayath Mahamadi" className="h-20 w-20 sm:h-24 sm:w-24 rounded-xl object-cover object-top bg-white" />
    <div className="min-w-0">
      <p className="font-display text-lg text-ink font-semibold">Dr. Vilayath Mahamadi</p>
      <p className="text-sm text-ink-muted">BDS · Cosmetic Dental Surgeon · 9+ years</p>
      <ul className="mt-2 space-y-1">
        {HIGHLIGHTS.map(({ icon: I, text }) => (
          <li key={text} className="flex items-start gap-2 text-sm text-ink"><I className="h-4 w-4 mt-0.5 text-teal shrink-0" />{text}</li>
        ))}
      </ul>
    </div>
  </div>
);

export const Hero = ({ config, preselect }) => (
  <section className="relative overflow-hidden" data-testid="hero-section">
    <div className="absolute inset-0 grain opacity-60 pointer-events-none" />
    <div className="absolute -top-32 -right-32 h-96 w-96 rounded-full bg-mint blur-3xl opacity-70 pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-16 grid lg:grid-cols-[1.05fr_0.95fr] gap-10 lg:gap-14 items-start">
      <div className="reveal lg:pt-6 min-w-0">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-teal-light">Smileton Dental · Sainikpuri, Secunderabad</p>
        <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-semibold text-ink leading-[1.08]" data-testid="hero-headline">
          Let smile be your signature, with <em className="text-teal not-italic">painless, precision</em> Dentistry in Sainikpuri
        </h1>
        <p className="mt-5 text-base md:text-lg text-ink-muted max-w-xl">
          Book a 30-minute in-clinic consultation directly with Dr. Vilayath Mahamadi. No account, no waiting on hold — pick a time and you're done in a minute.
        </p>
        <div className="mt-6 flex flex-wrap gap-2.5">
          {BADGES.map(({ icon: I, text }, i) => (
            <span key={text} data-testid={`hero-badge-${i}`} className="inline-flex items-center gap-2 rounded-full bg-mint text-teal border border-mint-border px-3.5 py-1.5 text-sm font-medium">
              <I className={`h-4 w-4 ${i === 0 ? "fill-gold text-gold" : ""}`} /> {text}
            </span>
          ))}
        </div>
        <DoctorCard />
      </div>
      <div className="reveal min-w-0" style={{ animationDelay: "120ms" }}>
        <BookingWidget config={config} preselect={preselect} />
      </div>
    </div>
  </section>
);
